import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Divider, Flex, Form, Input } from 'antd'
import { AddLinkFormFields } from './types'
import { assetNameCharacterLimit, descriptionCharacterLimit } from '../types'
import { normalizeUrl } from '../../../../modules/utils/helpers'

const { TextArea } = Input

type PropsType = {
  cancelCallBack: () => void
  submitCallBack: (formFields: AddLinkFormFields) => void
}

const DigitalAssetLinkForm: React.FC<PropsType> = ({ cancelCallBack, submitCallBack }: PropsType) => {
  const { t } = useTranslation(['digitalAsset', 'common', 'validation', 'digitalAssetOrder'])
  const [form] = Form.useForm<AddLinkFormFields>()

  const handleSubmit = (values: AddLinkFormFields) => {
    // Normalize the URL before submitting (adds www for better compatibility)
    const normalizedValues = {
      ...values,
      link_url: normalizeUrl(values.link_url),
    }
    submitCallBack(normalizedValues)
  }

  return (
    <Form onFinish={handleSubmit} form={form} layout="vertical">
      <Form.Item<AddLinkFormFields>
        label={t('form.linkLabel')}
        name="link_url"
        rules={[
          {
            required: true,
            message: t('form.rules.missingLink'),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item<AddLinkFormFields>
        label={t('form.assetName')}
        name="asset_name"
        rules={[
          {
            required: true,
            message: t('form.rules.missingAssetName'),
          },
          {
            max: assetNameCharacterLimit,
            message: `${assetNameCharacterLimit} ${t('form.rules.assetNameLimitReached')}`,
          },
        ]}
      >
        <TextArea
          rows={3}
          count={{
            max: assetNameCharacterLimit,
            show: true,
          }}
        />
      </Form.Item>
      <Form.Item
        name="description"
        rules={[
          {
            required: true,
            message: t('form.rules.missingDescription'),
          },
          {
            max: descriptionCharacterLimit,
            message: `${descriptionCharacterLimit} ${t('form.rules.descriptionLimitReached')}`,
          },
        ]}
        label={t('form.documentDescription')}
      >
        <TextArea
          rows={6}
          count={{
            max: descriptionCharacterLimit,
            show: true,
          }}
        />
      </Form.Item>
      <Divider />
      <Form.Item>
        <Flex justify="flex-end" gap="middle">
          <Button type="default" onClick={cancelCallBack}>
            {t('form.cancelButton')}
          </Button>
          <Button type="primary" htmlType="submit">
            {t('form.continueButton')}
          </Button>
        </Flex>
      </Form.Item>
    </Form>
  )
}
export default DigitalAssetLinkForm
